export const BrandsTableColumns = [
    { id: 'logo', labelEn: 'Logo', labelAr: 'الشعار', align: 'center' },
    { id: 'nameEn', labelEn: 'English Name', labelAr: 'الاسم (EN)', align: 'start' },
    { id: 'nameAr', labelEn: 'Arabic Name', labelAr: 'الاسم (AR)', align: 'start' },
    { id: 'slug', labelEn: 'Slug', labelAr: 'Slug', align: 'start' },
    { id: 'is_active', labelEn: 'Status', labelAr: 'الحالة', align: 'center' },
    { id: 'created_at', labelEn: 'Date', labelAr: 'التاريخ', align: 'start' },
];
